import { useRef } from 'react'

// Third party
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material'
import Accordion from '../../../../components/accordion/common/Accordion'

const ExhibitorCommentAccordion = (props: any) => {
  // Hooks and vars
  const textAreaText = useRef<string>('')
  const { commenttext } = props
  return (
    <Accordion
      icon={<AddCircleOutline className="add_icon text-[red]" />}
      initialState={true}
      className="mb-2"
      header="Comments"
      headerTextClassName="text-SeabiscuitDark200ThemeColor capitalize w-full pr-2"
      activeIcon={<RemoveCircleOutline className="add_icon text-[red]" />}
    >
      <textarea
        onChange={(e) => (textAreaText.current = e.target.value)}
        rows={6}
        disabled={!!commenttext}
        contentEditable={false}
        placeholder="Add note to customer...(optional)"
        className="w-full border border-solid !ring-0 !border-[white] bg-SeabiscuitGrayThemeColor !border-opacity-30 rounded-lg font-normal text-[14px] text-SeabiscuitDark200ThemeColor"
      >
        {commenttext ? commenttext.comment : null}
      </textarea>
    </Accordion>
  )
}

export default ExhibitorCommentAccordion
